<template>
    <div>
        <!-- 정보입력 -->
        <div class="join-row-wrap">
            <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">공개정보</h3>
                </div>

                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <myinfo-row v-if="isSupporter" label="닉네임">
                            <v-text-field v-model="user.nickname" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>

                        <myinfo-row label="연락처">
                            <v-row align="center">
                                <v-col class="py-0">
                                    <v-select v-model="user.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details class="rounded-0"></v-select>
                                </v-col>
                                -
                                <v-col class="py-0">
                                    <v-text-field v-model="user.phone2" maxlength="4" outlined hide-details @input="user.phone2 = user.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                </v-col>
                                -
                                <v-col class="py-0">
                                    <v-text-field v-model="user.phone3" maxlength="4" outlined hide-details @input="user.phone2 = user.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                </v-col>
                            </v-row>
                        </myinfo-row>

                        <myinfo-row label="이메일">
                            <v-text-field v-model="user.email" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>
                        <template v-if="isSupporter">
                            <myinfo-row label="전문가 소개">
                                <v-textarea v-model="user.summary" type="text" class="rounded-0" outlined hide-details :placeholder="`기업에서 조회하는 전문가 검색 섹션에 표시되는 부분입니다.\n전문분야 및 경력사항을 소개형태로 50자 이상 작성 부탁드립니다.`" />
                            </myinfo-row>
                            <myinfo-row label="사진">
                                <v-file-input v-model="user.avatar" dense hide-details outlined class="rounded-0" accept="image/*" />
                            </myinfo-row>
                        </template>
                        <template>
                            <myinfo-row>
                                <template slot="title">
                                    <div class="d-flex align-center"><span class="d-inline-block mr-1">정보공개동의</span><bottom-popup v-model="showEvent" /></div>
                                </template>
                                <!-- <v-row align="center">
                                    <v-col cols="auto">
                                        <v-switch label="검색노출" v-model="user.isDisplayed" inset class="ma-0 ml-1" />
                                    </v-col>
                                    <v-col cols="auto" class="ml-3"> -->
                                <v-switch label="연락처노출" v-model="user.isContactDisplayed" inset class="ma-0 ml-1" />
                                <!-- </v-col>
                                </v-row> -->
                            </myinfo-row>
                        </template>
                    </div>
                </div>
            </div>
            <modify-form-description v-if="user._id" v-model="user" />
        </div>
        <!-- 하단버튼 -->
        <div class="bottom-button">
            <button class="button button--border-primary" @click="cancel()">
                <span>취소하기</span>
            </button>
            <button class="button button--primary" @click="submit()">
                <span>저장하기</span>
            </button>
        </div>

        <daum-postcode ref="daum-postcode" @change="({ postcode, address }) => ((user.postcode = postcode) || true) && ((user.address1 = address) || true)" />
    </div>
</template>

<script>
import dayjs from "dayjs";
import { INDIVIDUAL_KINDS } from "@/assets/data/CONSTANTS";

import FormRow from "../form-row.vue";
import MyinfoRow from "@/components/client/mypage/myinfo-row.vue";
import MyinfoAreas from "@/components/client/mypage/myinfo-areas.vue";
import BottomPopup from "./bottom-popup.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import ModifyFormDescription from "@/components/client/experts/modify/modify-form-description.vue";

const initialUser = {
    kind: INDIVIDUAL_KINDS.SUPPORTER.value,
    affiliation: null,
    // department: null,
    residentNumber: null,
    residentNumber1: null,
    residentNumber2: null,
    postcode: null,
    address1: null,
    address2: null,
    _areas: [],
    areas_manual: {},
    summary: null,
    _avatar: null,
    isContactDisplayed: null,
};
export default {
    components: {
        FormRow,
        MyinfoRow,
        MyinfoAreas,
        BottomPopup,
        DaumPostcode,
        ModifyFormDescription,
    },
    props: ["value", "areas"],
    data() {
        return {
            user: { ...initialUser, ...this.$props.value } || { ...initialUser },
            INDIVIDUAL_KINDS,
            showEvent: true,
        };
    },
    computed: {
        isSupporter() {
            return this.user.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        "user.email"() {
            this.$emit("input", this.user);
        },
        "user.email1"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },
        "user.email2"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },

        "user.phone"() {
            this.$emit("input", this.user);
        },
        "user.phone1"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone2"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone3"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },

        "user.bornAt"() {
            this.$emit("input", this.user);
        },
        "user.residentNumber1"() {
            if (this.user.residentNumber1?.length == 6) {
                const year = dayjs().format("YY");
                const [yy, mm, dd] = this.user.residentNumber1.match(/.{1,2}/g);

                if (this.user.residentNumber2?.length > 0) {
                    const criterion = this.user.residentNumber2[0];
                    this.user.bornAt = [yy.padStart(4, +criterion < 3 ? "19" : "20"), mm, dd].join("-");
                } else this.user.bornAt = [yy.padStart(4, +yy > +year ? "19" : "20"), mm, dd].join("-");
            } else this.user.bornAt = null;

            this.user.residentNumber = `${this.user.residentNumber1}-${this.user.residentNumber2}`;
        },
        "user.residentNumber2"() {
            if (this.user.residentNumber1?.length == 6) {
                const year = dayjs().format("YY");
                const [yy, mm, dd] = this.user.residentNumber1.match(/.{1,2}/g);

                if (this.user.residentNumber2?.length > 0) {
                    const criterion = this.user.residentNumber2[0];
                    this.user.bornAt = [yy.padStart(4, +criterion < 3 ? "19" : "20"), mm, dd].join("-");
                } else this.user.bornAt = [yy.padStart(4, +yy > +year ? "19" : "20"), mm, dd].join("-");
            } else this.user.bornAt = null;

            this.user.residentNumber = `${this.user.residentNumber1}-${this.user.residentNumber2}`;
        },
    },
    methods: {
        sync() {
            this.user = { ...this.value };
        },
        input() {
            this.$emit("input", this.user);
        },
        onSearchPostcode() {
            this.$refs["daum-postcode"].open();
        },
        cancel() {
            this.$router.push("/");
        },

        submit() {
            if (this.validate()) this.$emit("save", this.user);
        },

        validate() {
            try {
                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },
    },
};
</script>
